import { render, staticRenderFns } from "./UploadZone.vue?vue&type=template&id=ae48eaaa&scoped=true&"
import script from "./UploadZone.vue?vue&type=script&lang=js&"
export * from "./UploadZone.vue?vue&type=script&lang=js&"
import style0 from "./UploadZone.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./UploadZone.vue?vue&type=style&index=1&id=ae48eaaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae48eaaa",
  null
  
)

export default component.exports